/*
 * PinPreview — a tiny, static map showing one pin, so picking a shop or
 * address shows you WHERE it lands before you commit. No panning or zoom; it
 * just confirms the spot. Renders nothing without real coordinates.
 *
 * Author: Maré Greyling (Thevertex) <mare.greyling@gmail.com> — https://mare-greyling.com
 */
import { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export default function PinPreview({ lat, lng, height = 130 }) {
  const el = useRef(null);
  useEffect(() => {
    const y = Number(lat);
    const x = Number(lng);
    if (!el.current || !isFinite(y) || !isFinite(x)) return undefined;
    const map = L.map(el.current, {
      zoomControl: false, attributionControl: false, dragging: false,
      scrollWheelZoom: false, doubleClickZoom: false, boxZoom: false,
      keyboard: false, tap: false, touchZoom: false,
    }).setView([y, x], 15);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19 })
      .addTo(map);
    L.circleMarker([y, x], {
      radius: 8, color: '#8B5CF6', weight: 2, fillColor: '#8B5CF6', fillOpacity: 0.9,
    }).addTo(map);
    const t = setTimeout(() => map.invalidateSize(), 60);
    return () => { clearTimeout(t); map.remove(); };
  }, [lat, lng]);

  const y = Number(lat);
  const x = Number(lng);
  if (!isFinite(y) || !isFinite(x)) return null;
  return (
    <div ref={el} style={{ height }}
         className="w-full rounded-xl overflow-hidden border border-edge mt-2" />
  );
}
